import { render, staticRenderFns } from "./SearchClasses.vue?vue&type=template&id=341b5aa4&scoped=true"
import script from "./SearchClasses.vue?vue&type=script&lang=js"
export * from "./SearchClasses.vue?vue&type=script&lang=js"
import style0 from "./SearchClasses.vue?vue&type=style&index=0&id=341b5aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b5aa4",
  null
  
)

export default component.exports